import React from 'react';
import { useState } from "react";
function ProductFeatures({data}) { 

  const [activeIndex, setActiveIndex] = useState(0);

  const handleMouseOver = (index) => {
    setActiveIndex(index);
  };

  const handleMouseOut = () => {
    setActiveIndex(0);
  };

  return (
    <>
      <section className='product-features' id='scrolled-demo'>
        <div className='container'>
          <div className='top-head'>
            <h2 className='ttl1'>Features</h2>
          </div>
          <div className='benifits-list'>
          {data.map((response, index) => (
            <div className={`lst-itm ${activeIndex === index ? "active" : ""}`} onMouseOver={() => handleMouseOver(index)}
              onMouseLeave={handleMouseOut} key={index}>
              <span className='img-cont'>
                  <img src={response.Img1} className='img-st' alt={response.FeatHeading} width={40} height={40} />
                  <img src={response.Img2} className='img-hvr' alt={response.FeatHeading} width={40} height={40} />
              </span>
              <h4>{response.FeatHeading}</h4>
            </div>
            ))}
          </div>
        </div>
      </section>
    </>

  )
}

export default ProductFeatures;
